var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorSwatch = function SvgColorSwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 47 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.396 10.922 6.78 29.502a7.58 7.58 0 1 0 10.72 10.72l18.579-18.618a4.034 4.034 0 0 0 0-5.682l-5-5a4.034 4.034 0 0 0-5.682 0M10.245 32.854a2.84 2.84 0 1 1 0 4.015 2.823 2.823 0 0 1-.114-4.015z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.396 10.922 6.78 29.502a7.58 7.58 0 1 0 10.72 10.72l18.579-18.618a4.034 4.034 0 0 0 0-5.682l-5-5a4.034 4.034 0 0 0-5.682 0M10.245 32.854a2.84 2.84 0 1 1 0 4.015 2.823 2.823 0 0 1-.114-4.015z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.905 37c0-.227-.151-.435-.19-.662.039.227.133.417.19.663M38.407 27.285h-7.974L17.497 40.221a7.58 7.58 0 0 1-5.36 2.216h26.27a4.034 4.034 0 0 0 4.034-4.034v-7.084a4.034 4.034 0 0 0-4.034-4.034M4.716 33.386c0-.228.132-.436.19-.663-.058.246-.152.435-.19.663",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.562 8.593v26.269a7.576 7.576 0 1 0 15.151 0V8.592a4.034 4.034 0 0 0-4.034-4.033H8.596a4.034 4.034 0 0 0-4.034 4.034m4.734 26.269a2.86 2.86 0 1 1 2.841 2.84 2.84 2.84 0 0 1-2.84-2.84"
  })));
};
export default SvgColorSwatch;